export const EXCEPTION_FAILED = 'Exception-Fail';
// 通常是遇到 API 500 錯誤使用
export const UNEXPECTED_ERROR = 'Unexpected-Error';
// 活動名稱帶有特殊符號
export const PROMO_NAME_INCLUDE_SPECIAL_SYMBOL = 'Promo-Name-Include-Special-Symbol';

/* 活動方案 & 活動上線錯誤 */
export const NO_PLAN = 'No-Plan';
export const NO_PLAN_FEATURE = 'No-Plan-Feature';
export const MISSING_TIME_ZONE = 'Missing-Time-Zone';
export const PERMISSION_DENIED = 'Permission-Denied';
export const PRIZE_PROBABILITY_NOT_FULL = 'Prize-Probability-Not-Full';
export const VALID_DATETIME_EMPTY = 'Valid-Datetime-Empty';
export const VALID_DATETIME_SETTING_ERROR = 'Valid-Datetime-Setting-Error';
export const VALID_DATETIME_EXPIRED = 'Valid-Datetime-Expired';
export const VALID_DATETIME_RANGE_NOT_IN_PLAN = 'Valid-Datetime-Range-Not-In-Plan';
export const NEED_TO_EXTEND_PROMO_END_DATE = 'Need-To-Extend-Promo-End-Date';
// 同一檔活動重複上線 (開多分頁時遇到)
export const PROMOTION_STATUS_INVALID = 'Promotion-Status-Invalid';
/* IG Hashtag 模組 */
export const INSTAGRAM_ID_NOT_FOUND = 'Instagram-Id-Not-Found';
export const INSTAGRAM_ACCOUNT_EXPIRED = 'Instagram-Account-Expired';
export const DUPLICATE_KEYWORD = 'Duplicate-Keyword';
export const DUPLICATE_HASHTAGS = 'Duplicate-Hashtags';
export const VERIFY_HASHTAGS_IS_NOT_EXIST = 'Verify-Hashtags-Is-Not-Exist';
export const VERIFY_PRIVATE_REPLY_KEYWORD_IS_NOT_EXIST =
    'Verify-Private-Reply-Keyword-Is-Not-Exist';
export const VERIFY_HASHTAGS_NOT_EMPTY = 'Verify-Hashtags-Not-Empty';
export const VERIFY_KEYWORD_NOT_EMPTY = 'Verify-Keyword-Not-Empty';
/* 上線 Campaign */
export const CAMPAIGN_ID_IS_INCORRECT = 'Campaign-Id-Is-Incorrect';
/* 多元任務模組 */
export const TASK_HAS_NOT_BOUND_VALID_PROMOTION = 'Task-Has-Not-Bound-Valid-Promotion';
/* 兑點模組 */
export const REDEEM_POINT_POOL_UUID_NOT_FOUND = 'Redeem-Point-Pool-UUID-Not-Found';
// 你設定的點數池已經被刪除 or DB連線錯 or 儲存的資料有錯 (這情況很少見所以找不到點數池)
export const REDEEM_POINT_POOL_NOT_FOUND = 'Redeem-Point-Pool-Not-Found';
/* 點數系統 */
export const POINT_PLAN_DATE_INVALID = 'Point-Plan-Date-Invalid';
export const POINT_POOL_STATUS_IS_PAUSE = 'Point-Pool-Status-Is-Pause';
export const POINT_POOL_STATUS_INVALID = 'Point-Pool-Status-Invalid';
// 通常是切換 lottery 時，突然網路有問題，導致點數池沒有正確關聯到點數獎品
export const POINT_SYSTEM_VALID_FAILED_NO_RELATION = 'Point-System-Valid-Failed-No-Relation';
// 通常是發生在複製A Sponsor 的活動 到 B Sponsor 時，該活動有綁定「全域點數池」，但複製到 B Sponsor 時，沒有 Sponsor B 沒有該全域點數池的權限
export const POINT_SYSTEM_VALID_FAILED_NO_PERMISSION = 'Point-System-Valid-Failed-No-Permission';
export const DEDUCTED_POINT_POOL_ID_NOT_FOUND = 'Deducted-Point-Pool-Id-Not-Found';
export const VERIFY_DEDUCTED_POINT_QUANTITY_IS_EMPTY = 'Verify-Deducted-Point-Quantity-Is-Empty';
export const REWARD_POINT_POOL_ID_NOT_FOUND = 'Reward-Point-Pool-Id-Not-Found';
//點數池已被刪除（ 這個情境應該不太可能出現）
export const POINT_POOL_DELETED = 'Point-Pool-Deleted';
/* 活動設定衝突錯誤 */
export const MGM_SELF_LOGIN_REQUIRED = 'MGM-Self-Login-Required';
export const SHARE_PRIZE_LOGIN_REQUIRED = 'Share-Prize-Login-Required';
export const REVALIDATION_PERIOD_VALIDATION_WARNING = 'Revalidation-Period-Validation-Warning';
